export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/elevator-ee3ae972b5dee01f4f75ecafa50f01ff.svg";